import { unwrap, type components } from "@wilco/api";
import { api } from "../auth.ts";
import type { ListQuery } from "../docs/DocumentList.tsx";
import { idempotency } from "../docs/DocumentForm.tsx";
import { pageQuery } from "../docs/serverPage.ts";

/*
 * Технологические карты маршрута для мастера дільниці (RTE-01, RTE-02,
 * RTE-20): список, карта целиком, новая карта с хвостом от сервера,
 * правка всех шагов, архив.
 */
type S = components["schemas"];

export type CardRow = S["RouteCardRow"];
export type CardDetail = S["RouteCardDetail"];
export type CardStep = S["RouteCardStepView"];
export type CardStepEdit = S["RouteCardStepEdit"];
export type CardInput = S["RouteCardInput"];

const id = (v: number) => ({ params: { path: { id: v } } });

export const cardsApi = {
  list: (a: Pick<ListQuery, "cursor" | "limit" | "q"> & { active: boolean | null }) =>
    unwrap(api.GET("/api/v1/route/cards", { params: { query: { ...pageQuery(a), q: a.q || undefined, active: a.active ?? undefined } } })),
  card: (v: number, version?: string) => unwrap(api.GET("/api/v1/route/cards/{id}", { params: { path: { id: v }, query: { version } } })),
  define: (body: CardInput, key: string) => unwrap(api.POST("/api/v1/route/cards", { body, headers: idempotency(key) })),
  edit: (v: number, body: S["RouteCardEdit"], key: string) => unwrap(api.PUT("/api/v1/route/cards/{id}", { ...id(v), body, headers: idempotency(key) })),
  archive: (v: number) => unwrap(api.POST("/api/v1/route/cards/{id}/archive", id(v))),
};
